import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link } from "react-router-dom"
import {getMasterTemp} from "../../../store/templates/actions"
import { map } from "lodash"
import axios from "axios"
import { API_URL } from "../../../helpers/app_url";
import cm from "../../../assets/img/page-1.png"
import lt from "../../../assets/img/page-2.png"
import { getProjectUUIDAction, loadlandingMasterTemplate } from "../../../store/actions"
import ProjectSidebar from "../../../components/VerticalLayout/ProjectSidebar";
import cm1 from "../../../assets/img/cm-1.jpg"
import cm2 from "../../../assets/img/cm-2.jpg"
import cm3 from "../../../assets/img/cm-3.jpg"
import lan1 from "../../../assets/img/lan-1.jpg"
import lan2 from "../../../assets/img/lan-2.jpg"
import lan3 from "../../../assets/img/lan-3.jpg"
import ld1 from "../../../assets/img/ld-1.jpg"
import ld2 from "../../../assets/img/ld-2.jpg"
import {
    Row,
    Col,
    CardBody,
    Card,
    Container,
    CardFooter,
    CardHeader,

  } from "reactstrap"

import Moment from "react-moment";
import WebpagesMenu from "./menu/webpages-menu";
import WebPageBreadcrumbs from "components/Common/WebpageBreadcrumb";
import CopyText from "components/buttons/copyBtn";

class projectLandingPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
          alltemplates:[]
   
        }

      }

     
        
      componentDidMount() {

        const { match: { params }, ongetProjectUUIDAction, onGetMasterTemp} = this.props;
    
        if (params && params.projectId) {
          ongetProjectUUIDAction(params.projectId);

          const obj = JSON.parse(localStorage.getItem("authUser"));
          const token = obj.resultData.bearerToken;
          const str = 'Bearer ' + token;
          
            axios.get('https://rscoreapi.azurewebsites.net/api/ProjectMasterLandingPageTemplate/alltemplates', { headers: { Authorization: str } })
              .then(res => {
                const alltemplates = res.data;
                this.setState({ alltemplates });
              })
        }
      }  
      
      handlePreview = (alltemplate) => {
        const { onGetTempById, landingMasterData } = this.props;
        const { projectId } = this.props.match.params;
        const userId = localStorage.getItem("userId");
      
        this.setState({ selectedTemplateId: alltemplate.id }, () => {
          onGetTempById(projectId, alltemplate.id, userId);
        });
      };
      componentDidUpdate(prevProps) {
        if (prevProps.landingMasterData !== this.props.landingMasterData) {
          const { landingMasterData, history } = this.props;
          const { projectId } = this.props.match.params;
          const { selectedTemplateId } = this.state;
      
          if (landingMasterData && selectedTemplateId) {
            const encodedData = encodeURIComponent(JSON.stringify(landingMasterData));
            const url = `/pre-construction/new-preview-page/${selectedTemplateId}/${projectId}/${selectedTemplateId}?previewData=${encodedData}`;
            history.push({
              pathname: `/pre-construction/new-preview-page/${selectedTemplateId}/${projectId}/${selectedTemplateId}`,
              state: { previewData: landingMasterData }
            });
          }
        }
      }
      render() {
        const { projectData, templates, isResponsive } = this.props;
        const { projectId } = this.props.match.params; // For class component
        const landingPageUrl = `https://pages.realtyspacehub.com/${projectId}`;

        return (
          <React.Fragment>
              <div className="page-content project-page-content">

                <MetaTags>
                <title>Campaigns | Realty Space</title>
                </MetaTags>
                <Container fluid className="ps-0 ">
                <Row>
                    <Col sm='2' className="pe-0" >
                    <ProjectSidebar isResponsive={isResponsive} />
                     </Col>
                <Col sm='10' className="ps-0">
                <Row className="project-header">
                   <Col sm="7">
                <WebPageBreadcrumbs title={this.props.t("Projects")} breadcrumbItem={this.props.t("Landing Page")} />
                </Col>
                <Col sm="4">
                <h2 className="">{this.props.t( projectData.projectName)}</h2>
                </Col>
                </Row>
                <WebpagesMenu isResponsive={isResponsive} />
                <Row>
                   
                    <Col lg="12">
                   
                        <Card>
                       <CardBody>
                        
                         
                          <Row>
                          
                                <Col sm="12">
                                  <h5><strong>Active Url: </strong>{projectData?.isLandingPagePublished ? (
  <>
    <a target="_blank" rel="noreferrer" href={landingPageUrl}>
      {landingPageUrl}
    </a>
    <CopyText textToCopy={landingPageUrl} />
  </>
) : (
  <>No landing page set. Please select a template from below.</>
)}</h5>
                                </Col>
                               </Row>
                         
                        
                              
                           
                        </CardBody> 
                      
                        </Card>
                        {!isResponsive && (
                        <Card>
                          <CardBody>
                              <h4 className="card-title mb-4">Select your landing page theme</h4>

                              <Row>
                              {
                              this.state.alltemplates.map(alltemplate => {
                                const imageMap = {
                                 
                                  47: lan1,
                                  37: lan2,
                                  6: lan3, 
                                  23: cm1, 
                                  8: cm2, 
                                  29: cm3, 
                                  24: cm2
                                };

                                const defaultImage = lt;
                                const agentId = localStorage.getItem('userId');
                                return (
                                  <Col sm="4" key={alltemplate.id}>
                                    <Card className="landingPageThumb">
                                      <CardHeader><h5>{alltemplate.templateTitle}</h5></CardHeader>
                                      <CardBody className="p-0">
                                      <div className="imgThubm">
                                        <Link to="#">
                                          <img 
                                            src={imageMap[alltemplate.id] || defaultImage}
                                            className="img-fluid"
                                            alt={`Template ${alltemplate.id}`}
                                          />
                                        </Link>
                                      </div>
                                      </CardBody>
                                      <CardFooter>
                                        <Row>
                                          <Col sm="6">
                                            <a target="_blank" rel="noreferrer" className="btn btn-landing-page" href={`https://pages.realtyspacehub.com/preview/${this.props.match.params.projectId}/${alltemplate.id}/${agentId}`}>Preview</a>
                                          </Col>

                                          <Col sm="6">
                                          <Link className="float-end btn btn-landing-page" to={`/pre-construction/landing-editor/${this.props.match.params.projectId}/${alltemplate.id}`}>Select</Link>
                                          </Col>
                                        </Row>
                                      </CardFooter>
                                      
                                    </Card>
                                  </Col>
                                );
                              })
                            }
                                  
                              </Row>

                             
                          </CardBody>
                        </Card>
                        )}
                    </Col>
                </Row>
                <Row>
                   
                </Row>
                </Col>
                </Row>
                </Container>
            </div>
          </React.Fragment>
        )
      }
}

projectLandingPage.propTypes = {
    t:PropTypes.any,
    history:PropTypes.object,
    match:PropTypes.object,
    ongetProjectUUIDAction:PropTypes.func,
    projectData: PropTypes.object,
    className: PropTypes.any,
    onGetMasterTemp:PropTypes.func,
    templates:PropTypes.array,
    onGetTempById:PropTypes.func,
    landingMasterData:PropTypes.object,
    isResponsive:PropTypes.object
  }
  const mapStateToProps = ({ Project,Template }) => (
    {
      projectData: Project.projectData,
      loading:Project.loading,
      templates: Template.templates,
      landingMasterData:Template.landingMasterData
  
    })
  const mapDispatchToProps = dispatch => ({
    ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
    onGetMasterTemp:(agentId) => dispatch(getMasterTemp(agentId)),
    onGetTempById:(projectId, templateId, userId) => dispatch(loadlandingMasterTemplate(projectId, templateId, userId))
  });
export default connect(mapStateToProps,mapDispatchToProps )(withRouter(withTranslation()(projectLandingPage)))
